export default __webpack_public_path__ + "static/media/active-community-marker.1761d982.png";